module.exports = __webpack_public_path__ + "static/media/icon-piece1-3.db5ae166.png";